import { useIsomorphicLayoutEffect } from "usehooks-ts";

/**
 * Ref-counted document scroll lock. Used to freeze the page while a right-click
 * suggestions menu is open, mimicking native context-menu behavior. Ref-counted
 * so overlapping locks (e.g. two suggestion mounts observing the same model)
 * don't clobber each other's restore.
 */
let lockCount = 0;
let prevOverflow = "";
let prevPaddingRight = "";

export function lockScroll(): void {
  if (typeof document === "undefined") return;

  if (lockCount === 0) {
    const { body } = document;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    prevOverflow = body.style.overflow;
    prevPaddingRight = body.style.paddingRight;

    body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  lockCount += 1;
}

export function unlockScroll(): void {
  if (typeof document === "undefined") return;

  lockCount = Math.max(0, lockCount - 1);

  if (lockCount === 0) {
    document.body.style.overflow = prevOverflow;
    document.body.style.paddingRight = prevPaddingRight;
  }
}

export function useScrollLock(enabled: boolean): void {
  useIsomorphicLayoutEffect(() => {
    if (!enabled) return undefined;

    lockScroll();
    return unlockScroll;
  }, [enabled]);
}
